export default __webpack_public_path__ + "images/4998362f204f2710506b6bc1045453e7.png";